// we rename these fields in the middleware bc numbers
export default function aliasCropNames(story) {
  return {
    ...story,
    primary_image: story.primary_image &&
      !!Object.keys(story.primary_image).length && {
        ...story.primary_image,
        crops: {
          lead: {
            ...story.primary_image.crops["16x9"],
          },
          square: {
            ...story.primary_image.crops["1x1"],
          },
        },
      },
    social_image: story.social_image &&
      !!Object.keys(story.social_image).length && {
        ...story.social_image,
        crops: {
          lead: {
            ...story.social_image.crops["16x9"],
          },
          square: {
            ...story.social_image.crops["1x1"],
          },
        },
      },
  };
}
